import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*
============
== POTREE ==
============

http://potree.org

Copyright (c) 2011-2020, Markus Schütz
All rights reserved.

    Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

    1. Redistributions of source code must retain the above copyright notice, this
list of conditions and the following disclaimer.
2. Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
and/or other materials provided with the distribution.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

    The views and conclusions contained in the software and documentation are those
of the authors and should not be interpreted as representing official policies,
    either expressed or implied, of the FreeBSD Project.
 */
import * as THREE from 'three';
import PointCloudNode from "./PointCloudNode"; // Create an A(xis)A(ligned)B(ounding)B(ox) for the child `childIndex` of one aabb.
// (PotreeConverter protocol builds implicit octree hierarchy by applying the same
// subdivision algo recursively)

var dHalfLength = new THREE.Vector3();
var NODE_TYPE = {
  NORMAL: 0,
  LEAF: 1,
  PROXY: 2
};

var Potree2Node = /*#__PURE__*/function (_PointCloudNode) {
  _inherits(Potree2Node, _PointCloudNode);

  var _super = _createSuper(Potree2Node);

  function Potree2Node() {
    var _this;

    var numPoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var childrenBitField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var layer = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, Potree2Node);

    _this = _super.call(this, numPoints, layer);
    _this.childrenBitField = childrenBitField;
    _this.id = '';
    _this.depth = 0;
    _this.baseurl = layer.source.baseurl;
    return _this;
  }

  _createClass(Potree2Node, [{
    key: "add",
    value: function add(node, indexChild) {
      _get(_getPrototypeOf(Potree2Node.prototype), "add", this).call(this, node, indexChild);

      node.id = this.id + indexChild;
      node.depth = this.depth + 1;
    }
  }, {
    key: "createChildAABB",
    value: function createChildAABB(node, childIndex) {
      // Code inspired from potree
      node.bbox.copy(this.bbox);
      this.bbox.getCenter(node.bbox.max);
      dHalfLength.copy(node.bbox.max).sub(this.bbox.min);

      if (childIndex === 1) {
        node.bbox.min.z += dHalfLength.z;
        node.bbox.max.z += dHalfLength.z;
      } else if (childIndex === 3) {
        node.bbox.min.z += dHalfLength.z;
        node.bbox.max.z += dHalfLength.z;
        node.bbox.min.y += dHalfLength.y;
        node.bbox.max.y += dHalfLength.y;
      } else if (childIndex === 0) {//
      } else if (childIndex === 2) {
        node.bbox.min.y += dHalfLength.y;
        node.bbox.max.y += dHalfLength.y;
      } else if (childIndex === 5) {
        node.bbox.min.z += dHalfLength.z;
        node.bbox.max.z += dHalfLength.z;
        node.bbox.min.x += dHalfLength.x;
        node.bbox.max.x += dHalfLength.x;
      } else if (childIndex === 7) {
        node.bbox.min.add(dHalfLength);
        node.bbox.max.add(dHalfLength);
      } else if (childIndex === 4) {
        node.bbox.min.x += dHalfLength.x;
        node.bbox.max.x += dHalfLength.x;
      } else if (childIndex === 6) {
        node.bbox.min.y += dHalfLength.y;
        node.bbox.max.y += dHalfLength.y;
        node.bbox.min.x += dHalfLength.x;
        node.bbox.max.x += dHalfLength.x;
      }
    }
  }, {
    key: "octreeIsLoaded",
    get: function get() {
      return !(this.childrenBitField && this.children.length === 0);
    }
  }, {
    key: "url",
    get: function get() {
      return "".concat(this.baseurl, "/octree.bin");
    }
  }, {
    key: "networkOptions",
    value: function (byteOffset, byteSize) {
      var first = byteOffset;

      var networkOptions = _objectSpread(_objectSpread({}, this.layer.source.networkOptions), {}, {
        headers: _objectSpread(_objectSpread({}, this.layer.source.networkOptions.headers), {}, {
          'content-type': 'multipart/byteranges',
          Range: "bytes=".concat(first, "-").concat(first + byteSize - 1n)
        })
      });

      return networkOptions;
    }
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function (_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.octreeIsLoaded) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.loadOctree();

              case 3:
                return _context.abrupt("return", this.layer.source.fetcher(this.url, this.networkOptions(this.byteOffset, this.byteSize)).then(function (file) {
                  return _this2.layer.source.parser(file, {
                    "in": {
                      source: _this2.layer.source,
                      bbox: _this2.bbox,
                      numPoints: _this2.numPoints
                    },
                    out: _this2.layer
                  });
                }).then(function (data) {
                  _this2.loaded = true;
                  _this2.loading = false;
                  return data.geometry;
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function load() {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "loadOctree",
    value: function () {
      var _loadOctree = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.loaded || this.loading)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                this.loading = true;
                return _context2.abrupt("return", this.nodeType === NODE_TYPE.PROXY ? this.loadHierarchy() : Promise.resolve());

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadOctree() {
        return _loadOctree.apply(this, arguments);
      }

      return loadOctree;
    }()
  }, {
    key: "loadHierarchy",
    value: function () {
      var _loadHierarchy = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var hierarchyPath, buffer;
        return _regeneratorRuntime.wrap(function (_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                hierarchyPath = "".concat(this.baseurl, "/hierarchy.bin");
                _context3.next = 3;
                return this.layer.source.fetcher(hierarchyPath, this.networkOptions(this.hierarchyByteOffset, this.hierarchyByteSize));

              case 3:
                buffer = _context3.sent;
                this.parseHierarchy(buffer);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function loadHierarchy() {
        return _loadHierarchy.apply(this, arguments);
      }

      return loadHierarchy;
    }()
  }, {
    key: "parseHierarchy",
    value: function parseHierarchy(buffer) {
      var view = new DataView(buffer);
      var bytesPerNode = 22;
      var numNodes = buffer.byteLength / bytesPerNode;
      var stack = [];
      stack.push(this);

      for (var indexNode = 0; indexNode < numNodes; indexNode++) {
        var current = stack.shift();
        var offset = indexNode * bytesPerNode;
        var type = view.getUint8(offset + 0);
        var childMask = view.getUint8(offset + 1);
        var numPoints = view.getUint32(offset + 2, true);
        var byteOffset = view.getBigInt64(offset + 6, true);
        var byteSize = view.getBigInt64(offset + 14, true);

        if (current.nodeType === NODE_TYPE.PROXY) {
          // replace proxy with real node
          current.byteOffset = byteOffset;
          current.byteSize = byteSize;
          current.numPoints = numPoints;
        } else if (type === NODE_TYPE.PROXY) {
          // load proxy
          current.hierarchyByteOffset = byteOffset;
          current.hierarchyByteSize = byteSize;
          current.numPoints = numPoints;
        } else {
          // load real node
          current.byteOffset = byteOffset;
          current.byteSize = byteSize;
          current.numPoints = numPoints;
        }

        if (current.byteSize === 0n) {
          // workaround for issue potree/potree#1125
          // some inner nodes erroneously report >0 points even though have 0 points
          // however, they still report a byteSize of 0, so based on that we now set node.numPoints to 0
          current.numPoints = 0;
        }

        current.nodeType = type;

        if (current.nodeType === NODE_TYPE.PROXY) {
          continue;
        }

        for (var childIndex = 0; childIndex < 8; childIndex++) {
          var childExists = (1 << childIndex & childMask) !== 0;

          if (!childExists) {
            continue;
          }

          var child = new Potree2Node(numPoints, childMask, this.layer);
          child.spacing = current.spacing / 2;
          current.add(child, childIndex);
          stack.push(child);
        }
      }
    }
  }]);

  return Potree2Node;
}(PointCloudNode);

export default Potree2Node;